import React from 'react';
import { ReixSelect } from '../common/dropdowns/ReixSelect';

export enum ViewOptions {
  images,
  map,
  streetView,
}

type PropertyDetailsViewSelectProps = {
  activeView: ViewOptions;
  setActiveView: (view: ViewOptions) => void;
};

export const PropertyDetailsViewSelect = ({
  activeView,
  setActiveView,
}: PropertyDetailsViewSelectProps) => {
  const options = [
    { value: ViewOptions.images, label: 'MLS Image Gallery' },
    { value: ViewOptions.map, label: 'Map' },
    { value: ViewOptions.streetView, label: 'Street View' },
  ];

  return (
    <ReixSelect value={activeView} setValue={setActiveView} options={options} />
  );
};
